import React from 'react';
import { Document, Page } from '@react-pdf/renderer';
import Header from './SchedulePDFHeader';
import Footer from './SchedulePDFFooter';
import EachPageFooter from './SchedulePDFEachPageFooter';

import SchedulePDFTable from './SchedulePDFTable';
import { paginate } from '../../../Transcript/SchedulePDFUtils';
import styles from '../../../Transcript/SchedulePDFStyles';

const SchedulePDFMyDocument = ({ data,firstName,lastName,userName,dob  }) => {
  const pages = paginate(data);

  const completedDates = data.map(item => new Date(item.completeddate));
  const minDate = new Date(Math.min(...completedDates));
  const maxDate = new Date(Math.max(...completedDates));

  return (
   
    
    <Document>
      {pages.length > 0 ? (
pages.map((chunk, pageIndex) => (
        <Page key={pageIndex} style={styles.page}>
          <Header minDate={minDate} maxDate={maxDate} firstName={firstName} lastName={lastName} userName={userName} dob={dob} />
          {chunk.length >0 && (
          <SchedulePDFTable chunk={chunk} />
)}
          {pageIndex === pages.length - 1 && (
        <Footer minDate={minDate} maxDate={maxDate} />
      )}

          <EachPageFooter minDate={minDate} maxDate={maxDate} /> 
           {/* {pageIndex === pages.length - 1 ? (
  <Footer minDate={minDate} maxDate={maxDate} />
  
) : (
 <EachPageFooter minDate={minDate} maxDate={maxDate} />
)} */}


        </Page>
      ))) : (
      <Page key={0} style={styles.page}>
        <Header
          minDate={minDate}
          maxDate={maxDate}
          firstName={firstName}
          lastName={lastName}
          userName={userName}
          dob={dob}
        />
        <SchedulePDFTable chunk={[]} />
           <EachPageFooter minDate={minDate} maxDate={maxDate} />
        {/* <Footer minDate={minDate} maxDate={maxDate} /> */}
      </Page>
    )}
    </Document>
  );
};

export default SchedulePDFMyDocument;

